import type {LanguageCode} from '@/locale/locales'

export const getLanguageName = (languageCode: LanguageCode, targetLanguageCode?: LanguageCode) => {
    const languageNames = new Intl.DisplayNames(targetLanguageCode || languageCode, {
        type: 'language',
    })

    return languageNames.of(languageCode)
}
